<template>
  <div class="printOrderListBox">
    <el-tabs v-model="activeName" class="orderListTabs" @tab-click="searchInfo">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.id"
        :label="item.name"
        :name="item.id"
      >
      </el-tab-pane>
    </el-tabs>
    <div>
      <div class="orderSearchBox">
        <!--<el-date-picker
          v-model="createDateValue"
          type="date"
          placeholder="创建时间"
        >
        </el-date-picker>-->
       <div class="timeSearch">
         <span style="color: #b2b2b2;">区间筛选</span>
         <el-date-picker
            v-model="createDateValue"
            @change="chooseDate"
            type="daterange"
             value-format="yyyy-MM-dd"
            range-separator="—"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
        </el-date-picker>
      </div>
        <el-input v-model="modelNameValue" placeholder="需求名称"></el-input>
        <el-input
          v-model="merchantNameValue"
          placeholder="设计师名称"
        ></el-input>
        <el-input v-model="orderNumberValue" placeholder="订单编号"></el-input>
        <!--<el-select v-model="orderStatusValue" placeholder="订单状态">
          <el-option label="待付款" value="UN_PAY"> </el-option>
          <el-option label="完成" value="FINISHED"> </el-option>
        </el-select>-->
        <!--<el-select v-model="evaluateStatusValue" placeholder="评价状态">-->
          <!--<el-option label="好评" value="好评"> </el-option>-->
          <!--<el-option label="中评" value="中评"> </el-option>-->
          <!--<el-option label="差评" value="差评"> </el-option>-->
        <!--</el-select>-->
        <el-select v-model="postSalesServiceValue" placeholder="售后服务">
          <el-option label="仅退款" value="仅退款"> </el-option>
          <el-option label="退款退货" value="退款退货"> </el-option>
          <el-option label="换货" value="换货"> </el-option>
        </el-select>
        <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
        <el-button type="text" class="resetBtn" @click="clearSearch">
          <i class="iconfont icon-qingchushujuku"></i>
          <span>清除条件</span>
        </el-button>
      </div>
      <div class="orderListTable">
        <ul class="tableHeader">
          <li class="name">需求内容</li>
          <li class="price">预算</li>
          <li class="time">报价截止日期</li>
          <li class="num">报价人数</li>
          <li class="designer">设计师</li>
          <li class="offer">报价</li>
          <li class="expect">计划工期</li>
          <li class="status">订单状态</li>
          <li class="status">开票状态</li>
          <li class="status">操作</li>
        </ul>
        <ul class="tableBody" v-if="designList.length != 0" v-loading="loading">
          <li
            class="bodyItem"
            v-for="(designItems, designIndex) in designList"
            :key="designIndex"
          >
            <div class="itemTop">
               <div>订单编号：{{ designItems.orderBase.orderNo }}</div>
              <div>创建时间：{{ designItems.orderBase.createDate }}</div>
            </div>
            <div class="itemBottom">
              <div class="name">
                <div class="orderInfo">
                  <div class="infoContent">
                    <div class="infoName">{{ designItems.demandName }}</div>
                    <div class="infoOther">
                      {{ designItems.demandRemark }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="price">￥{{ designItems.lowPreAmount }}-{{ designItems.highPreAmount }}</div>
              <div class="time">{{ designItems.deadLine }}</div>
              <div class="num">{{ designItems.offerNum }}</div>
              <!-- <div class="arguments"> -->
              <div class="designer">
                <div class="designerName">
                  <img
                    v-if="designItems.headUrl == '' ? false : true"
                    :src="designItems.headUrl"
                    alt=""
                  />
                  <img src="../../../assets/images/default_header.png" v-else alt="" />
                </div>
                <div class="designerName">{{ designItems.designerName }}</div>
                <!-- <i class="iconfont icon-weixin" @click="startChat(designItems.enterPriseId)"></i> -->
                <i class="iconfont icon-weixin" @click="startChat(designItems.designerUuid)"></i>
              </div>
              <div class="offer">￥{{ designItems.offerPrice }}</div>
              <div class="expect">{{ designItems.planDeliveryTime }}</div>
                <div class="status">
                    {{ designItems.designStatusCn }}
                    <el-button type="text" class="operationBtn" @click="designOrderDetail(designItems)">订单详情</el-button>
                </div>
              <div class="status">
                  <div>{{ designItems.invoiceStatus==null?"未开票":designItems.invoiceStatus=="EXAMINE"?'开票中':designItems.invoiceStatus=='PASS'?'已开票':'已拒绝' }}</div>
              </div>
              <div class="operation">
                <el-button type="text" class="operationUploadBtn" v-if="designItems.designStatus==='UN_PAY'" @click="submitPay(designItems.orderBase)">付款</el-button>
                <el-button type="text" class="operationUploadBtn" v-if="designItems.designStatus==='UN_PAY' || designItems.designStatus=='PLATFORM_ADVANCES_UN_CONFIRM'" @click="cancelOrder(designItems)">取消订单</el-button>
                <el-button type="text" class="operationUploadBtn"
                           v-if="designItems.designStatus!=='UN_PAY'
                           && designItems.designStatus!=='UN_CANCEL'
                           && designItems.designStatus !== 'AFTER_SALES'
                           && designItems.orderBase.afterSaleAuditStatus !== 'PASS'
                           && designItems.invoiceStatus === null" @click="openInvoice(designItems)">申请开票</el-button>
                <!-- || designItems.designStatus==='UN_APPRAISE' -->
                <el-button type="text" class="operationUploadBtn"
                           v-if="designItems.designStatus!=='UN_PAY'
                            && designItems.designStatus!=='UN_CANCEL'
                            && designItems.designStatus !== 'AFTER_SALES'
                            && designItems.designStatus !== 'OFFLINE_UN_CONFIRM'
                            && designItems.designStatus !== 'PLATFORM_ADVANCES_UN_CONFIRM'
                            && designItems.designStatus !== 'DELIVERY_ON_CASH_UN_CONFIRM'
                            && designItems.designStatus !== 'UN_APPRAISE'
                            && designItems.designStatus !== 'FINISHED'
                            && (designItems.orderBase.afterSaleUuid===null || (designItems.orderBase.afterSaleUuid!==null&&designItems.orderBase.afterSaleAuditStatus==='REJECT'))
                            && designItems.orderBase.splitStatus === 'NONE'"
                           @click="AfterSales(designItems.orderBase.uuid,designItems.designerUuid,designItems.designerName,designItems.designStatus,designItems.orderBase.totalPrice)">申请售后</el-button>
                <el-button type="text" class="operationUploadBtn"
                           v-if="designItems.designStatus ==='OFFLINE_UN_CONFIRM'
                           || designItems.designStatus==='PLATFORM_ADVANCES_UN_CONFIRM'
                           || designItems.designStatus==='UN_DESIGN'
                           || designItems.designStatus==='UN_CONFIRM'
                           || designItems.designStatus==='AFTER_SALES'
                           || designItems.designStatus==='FINISHED'
                           || designItems.designStatus==='UN_APPRAISE'"
                           @click="complain(designItems.orderBase.uuid,designItems.designerUuid,designItems.designerName)">
                    投诉
                </el-button>
                <span>
                  <el-popconfirm
                    title="确认要通过验收吗？"
                    @confirm="confirmDesign(designItems)"
                  >
                     <el-button type="text"  slot="reference" class="operationUploadBtn" v-if="designItems.designStatus==='UN_CONFIRM'">确认验收</el-button>
                  </el-popconfirm>

                  </span>
                <!-- <el-button type="text" class="operationUploadBtn" v-if="designItems.designStatus==='UN_CONFIRM'" @click="confirmDesign(designItems)">确认设计</el-button> -->
                <el-button type="text" class="operationUploadBtn" v-if="designItems.designStatus==='UN_CONFIRM'" @click="updateRemarkInfo(designItems)">修改意见</el-button>
                <el-button type="text" class="operationUploadBtn" v-if="designItems.designStatus==='UN_APPRAISE'" @click="evaluateInfo(designItems)">评价</el-button>
                <el-button type="text" class="operationUploadBtn"
                           v-if="(designItems.designStatus==='FINISHED'
                || designItems.designStatus==='UN_APPRAISE') && designItems.orderBase.afterSaleAuditStatus !== 'PASS'" @click="downloadDesignFile(designItems)">下载文件</el-button>
              </div>
            </div>
          </li>
        </ul>
        <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
        <div class="orderNomesaage" v-loading="loading" v-else >
          <img src="../../../assets/暂无订单.jpg" alt="" style="width:200px">
        </div>
      </div>
    </div>
    <el-pagination
      v-if="designList.length != 0"
      background
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
      layout="total,prev, pager, next,jumper"
      :page-size="pageSize"
      :total="total"
      class="pagination"
    >
    </el-pagination>
    <amendments-dialog
      ref="amendmentsDialog"
    ></amendments-dialog>
      <el-dialog
          title="修改意见"
          :visible.sync="updateDialogVisible"
          :close-on-click-modal="false"
          width="1000px">
          <div class="logisticsDialog">
              <el-form ref="logisticsForm" class="demo-ruleForm">
                  <el-form-item prop="updateRemark">
                      <el-input type="textarea" :autosize="{ minRows: 6}"
                                v-model="updateRemark"
                                placeholder="请输入修改意见"></el-input>
                  </el-form-item>
                  <el-form-item class="submitButtonGroup">
                      <el-button type="primary" @click="updateSubmit">确定</el-button>
                      <el-button @click="updateDialogVisible = false">取消</el-button>
                  </el-form-item>
              </el-form>
          </div>
      </el-dialog>
      <!-- 取消订单 -->
      <el-dialog
          title="取消订单"
          :visible.sync="cancelDialogVisible"
          :close-on-click-modal="false"
          width="1000px">
          <div class="logisticsDialog">
              <el-form ref="logisticsForm" :rules="cancelRules" class="demo-ruleForm">
                  <el-form-item class="addressList">
                      <el-select v-model="cancelUuid" placeholder="取消原因">
                          <el-option v-for="(item,index) in cancelList" :key="index"
                                     :label="item.name"
                                     :value="item.uuid">
                          </el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item class="submitButtonGroup">
                      <el-button type="primary" @click="cancelSubmit">确定</el-button>
                      <el-button @click="cancelDialogVisible = false">取消</el-button>
                  </el-form-item>
              </el-form>
          </div>
      </el-dialog>
      <!--评价弹出框-->
      <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
          <div class="evaluateDialogBox">
              <div class="evaluateItem">
                  <div class="name">评价等级</div>
                  <div class="content">
                      <div class="rateItem">
                          <div class="name">描述相符</div>
                          <el-rate
                              v-model="evaluateForm.descriptionPoint"
                              show-score
                              text-color="#ff9900"
                          >
                          </el-rate>
                      </div>
                      <div class="rateItem">
                          <div class="name">服务态度</div>
                          <el-rate
                              v-model="evaluateForm.servicePoint"
                              show-score
                              text-color="#ff9900"
                          >
                          </el-rate>
                      </div>
                      <div class="rateItem">
                          <div class="name">专业程度</div>
                          <el-rate
                              v-model="evaluateForm.transportPoint"
                              show-score
                              text-color="#ff9900"
                          >
                          </el-rate>
                      </div>
                  </div>
              </div>
              <div class="evaluateItem">
                  <div class="name">评价标签</div>
                  <div class="content">
                      <el-checkbox-group
                          v-model="evaluateForm.evaluationTagList"
                          class="evaluateTag"
                      >
                          <el-checkbox-button
                              v-for="tag in tagList"
                              :label="tag"
                              :key="tag.tagUuid"
                          >{{ tag.tagName }}</el-checkbox-button
                          >
                      </el-checkbox-group>
                  </div>
              </div>
              <div class="evaluateItem">
                  <div class="name">评价内容</div>
                  <div class="content">
                      <el-input
                          type="textarea"
                          :autosize="{ minRows: 6 }"
                          placeholder="请输入内容"
                          v-model="evaluateForm.evaluationContent"
                      >
                      </el-input>
                  </div>
              </div>
          </div>
          <span slot="footer" class="dialog-footer">
                <el-button @click="evaluateDialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
            </span>
      </el-dialog>

      <!--聊天窗口-->
      <!-- <chat-dialog ref="chatDialogRef"></chat-dialog> -->

      <!-- 申请开票 -->
      <issue-invoice-dialog ref="invoiceDialogRef"></issue-invoice-dialog>

      <!-- 申请售后 -->
      <after-sales-dialog
          ref="afterSalesDialog"
      ></after-sales-dialog>

      <!-- 投诉弹窗 -->
      <complaints-dialog
          ref="dialogRef"
      ></complaints-dialog>
      <!--聊天窗口-->
      <chat-dialog ref="chatDialogRef"></chat-dialog>
      <!-- 购买的弹窗 -->
      <PayModelDialog ref="payModelRef" @refreshData="getList"/>
      <!-- 付款方式 -->
      <TermsOfPayment ref="termsOfPaymentRef" @offlinePay="offlinePayOrder"/>
  </div>
</template>

<script>
import { downLoad } from "../../../utils/downLoadModel";
import issueInvoiceDialog from "./issueInvoiceDialog"
import amendmentsDialog from './amendmentsDialog'
import {
    getDesignOrderList, updateDesignOrderStatus, getDictionaryItem, getDesignerDemandFile,
    addConfirmTime, addUpdateRemark, saveEvaluation, getRongCloudUser, offlinePay, platformAdvances
} from '../../../utils/interface';
import afterSalesDialog from "./afterSalesDialog";
import chatDialog from "../../../components/chat/chatDialog";
import complaintsDialog from "./complaintsDialog";
import PayModelDialog from "./payModelDialog";
import TermsOfPayment from '../../../components/termsOfPayment/termsOfPayment1'
export default {
  name: "printOrderList",
  components: {
    amendmentsDialog,
    afterSalesDialog,
    chatDialog,
    complaintsDialog,
    issueInvoiceDialog,
      PayModelDialog,
      TermsOfPayment
  },
  data() {
    return {
        stepLoading: false,
      loading: true,
      activeName: "0",
      tabList: [
          {
              id: '',
              name: '全部'
          },
          {
              id: 'UN_PAY',
              name: '待付款'
          },
          {
              id: "PLATFORM_ADVANCES_UN_CONFIRM",
              name: "先行支付确认中",
          },
          {
              id: 'UN_DESIGN',
              name: '设计中'
          },
          {
              id: 'UN_CONFIRM',
              name: '设计待确认'
          },
          {
              id: 'UN_APPRAISE',
              name: '待评价'
          }
      ],
      createDateValue: null,
        startTime:"",
        endTime:"",
      modelNameValue: "",
      merchantNameValue: "",
      orderNumberValue: "",
      orderStatusValue: "",
      evaluateStatusValue: "",
      postSalesServiceValue: "",
      designList: [],
      //   分页
      pageNo: 1,
      total: 0,
      pageSize: 8,
        // 修改意见
        updateDialogVisible:false,
        updateRemark:"",
        demandUuid:"",
        uuid:"",
        // 取消
        cancelDialogVisible: false,
        cancelList: [],
        cancelUuid: "",
        orderBaseUuid: "",
        cancelRules: {
            cancelUuid: [
                {required: true, message: '请选择取消原因', trigger: 'change'}
            ]
        },
        order:{},
        // 评价
        evaluateDialogVisible: false,
        evaluateForm: {
            descriptionPoint: 0,
            servicePoint: 0,
            transportPoint: 0,
            evaluationTagList: [],
            evaluationContent: "",
        },
        tagList: [],
    };
  },
    created(){
        this.getList();
        this.getDictionaryItem();
    },
  methods: {
      clearSearch(){
          this.modelNameValue = '';
          this.merchantNameValue = '';
          this.orderNumberValue = '';
          this.orderStatusValue = '';
          this.evaluateStatusValue = '';
          this.postSalesServiceValue = '';
          this.createDateValue = null;
          this.startTime = "";
          this.endTime = "";
          this.searchInfo();
      },
      searchInfo(){
          this.pageNo = 1;
          this.getList();
      },
      getList(){
          this.loading = true
          let params = {
              orderNo:this.orderNumberValue,
              demandName:this.modelNameValue,
              designerName:this.merchantNameValue,
              //createDate:this.createDateValue==null?null : this.createDateValue.getFullYear() +'-'+ (this.createDateValue.getMonth() + 1) +'-'+this.createDateValue.getDate(),
              startDate:this.startTime,
              endDate:this.endTime,
              orderStatus:this.activeName=='0'?'':this.activeName,
              isBuy:true,
              current:this.pageNo,
              pageSize:this.pageSize
          };
          getDesignOrderList(params).then((res)=>{
            console.log('res.data', res.data)
              this.designList = res.data;
              this.total = res.total;
              this.loading = false
          });
      },
      // 分页
      handleCurrentChange(val) {
          this.pageNo = val;
          this.getList();
      },
      // 时间格式
      chooseDate(){
          this.startTime = "";
          this.endTime = "";
          // 判断时间
          if(this.createDateValue!=null && this.createDateValue.length==2){
              this.startTime = this.timeDate(this.createDateValue[0]);
              this.endTime = this.timeDate(this.createDateValue[1]);
          }
      },
      timeDate(value){
          let date = new Date(value);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? "0" + MM : MM;
          let d = date.getDate();
          d = d < 10 ? "0" + d : d;
          return y + "-" + MM + "-" + d;
      },
      // 支付
      submitPay(item){
          // this.order = item;
          // 付款的选择弹窗
          this.$refs.termsOfPaymentRef.init(item)

          // this.$refs.payModelRef.init(item)
          // window.open(this.$url.payUrl + item.orderNo, "_blank");
          /*updateDesignOrderStatus({uuid:item.uuid,status:"UN_DESIGN"}).then((res)=>{
              if(res.success){
                  this.$message.success('订单支付成功！');
                  this.getList();
              }
          });*/
      },
      //线下支付上传凭证
      offlinePayOrder(obj){
          if(obj.radio == 1){
              this.$refs.payModelRef.init();
              window.open(this.$url.payUrl + obj.order.orderNo, "_blank");
          } else if(obj.radio == 2 && obj.imageUrl != '' && obj.imageUrl != null){
              let form ={orderNo: obj.order.orderNo, orderBaseUuid: obj.order.uuid, payTicket: obj.imageUrl};
              offlinePay(form).then(res=> {
                  console.log(res);
                  if (res && res.success) {
                      this.$message.success(res.message);
                  }else {
                      this.$message.error(res.message);
                  }
                  this.order = {};
                  this.getList();
              });
          } else if(obj.radio == 3){
              let form ={orderNo: obj.order.orderNo, orderBaseUuid: obj.order.uuid, payTicket: "PLATFORM_ADVANCES"};
              platformAdvances(form).then(res=> {
                  console.log(res);
                  if (res && res.success) {
                      this.$message.success(res.message);
                  }else {
                      this.$message.error(res.message);
                  }
                  this.order = {};
                  this.getList();
              });
          }
      },
      // 取消
      cancelOrder(item){
          getDictionaryItem({groupCode:"design_cancel_reason"}).then((res)=>{
              this.cancelList = res;
              this.uuid = item.uuid;
              this.cancelDialogVisible = true;
          });
      },
      // 取消确定
      cancelSubmit(){
          if(this.cancelUuid==""){
              this.$message.error('请选择取消原因！');
              return false;
          }
          updateDesignOrderStatus({uuid: this.uuid,status:"UN_CANCEL",cancelOrderUuid:this.cancelUuid}).then((res)=>{
              if(res.success){
                  this.$message.success('订单取消成功！');
                  this.cancelDialogVisible = false;
                  this.getList();
              }
          });
      },
      // 修改意见
      updateRemarkInfo(item){
          this.uuid = item.uuid;
          this.demandUuid = item.demandUuid;
          this.updateRemark = "";
          this.updateDialogVisible = true;
      },
      updateSubmit(){
          if(this.updateRemark===""){
              this.$message.error("请输入修改意见");
              return false;
          }else{
              addUpdateRemark({remark:this.updateRemark,demandUuid:this.demandUuid}).then((res)=>{
                  if(res.success){
                      updateDesignOrderStatus({uuid:this.uuid,status:"UN_DESIGN"}).then((res)=>{
                          if(res.success){
                              this.$message.success('已提交修改意见，待设计师修改！');
                              this.updateDialogVisible = false;
                              this.getList();
                          }
                      });
                  }
              });
          }
      },
      // 确认设计
      confirmDesign(item){
          addConfirmTime({demandUuid:item.demandUuid}).then((res)=>{
             if(res.success){
                 updateDesignOrderStatus({uuid:item.uuid,status:"UN_APPRAISE"}).then((res)=>{
                     if(res.success){
                         this.$message.success('需求设计确认成功！');
                         this.getList();
                     }
                 });
             }
          });
      },
      // 获取字典值
      getDictionaryItem() {
          getDictionaryItem({groupCode: "design_evaluation_tag"}).then((res) => {
              this.tagList = [];
              res.forEach((item, index) => {
                  this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
              });
          });
      },
      // 点击打开评价弹出框
      evaluateInfo(order) {
          this.order = order;
          this.evaluateForm = {
              descriptionPoint: 0,
              servicePoint: 0,
              transportPoint: 0,
              evaluationTagList: [],
              evaluationContent: "",
          };
          this.evaluateDialogVisible = true;
      },
      evaluateSubmit(){
          this.stepLoading = true;
          if (
              this.evaluateForm.descriptionPoint &&
              this.evaluateForm.servicePoint &&
              this.evaluateForm.transportPoint
          ) {
              this.evaluateForm.orderNo = this.order.orderBase.orderNo;
              this.evaluateForm.orderUuid = this.order.uuid;
              this.evaluateForm.orderType = 'DESIGN';
              this.evaluateForm.evaluationType = 'NORMAL';
              this.evaluateForm.sellerName = this.order.designerName;
              this.evaluateForm.sellerUuid = this.order.designerUuid;
              this.evaluateForm.orderName = this.order.demandName;
              this.evaluateForm.orderAmount = this.order.offerPrice;

              saveEvaluation(this.evaluateForm).then((response) => {
                  if (response.success) {
                      this.evaluateDialogVisible = false;
                      this.getList();
                      this.$message({
                          type: "success",
                          message: "评价成功",
                      });
                  } else {
                      this.$message({
                          type: "error",
                          message: response.message,
                      });
                  }
              });
          } else {
              this.$message.warning("请选择评价等级");
          }
          setTimeout(() => {
              this.stepLoading = false;
          }, 1000);
      },
      // // 待评价
      // appraiseDesign(item){
      //     updateDesignOrderStatus({uuid:item.uuid,status:"FINISHED"}).then((res)=>{
      //         if(res.success){
      //             this.$message.success('需求评价完成！');
      //             this.getList();
      //         }
      //     });
      // },
      // 订单详情
      designOrderDetail(item){
          this.$router.push({name:'designOrderDetail',params:{uuid:item.uuid}});
      },
      // 修改意见
      amendmentsDialog(){
          this.$refs.amendmentsDialog.init()
      },
      // 申请售后
      AfterSales(orderBaseUuid, targetUserUuid, enterPriseName, orderStatus,totalPrice){
          this.$refs.afterSalesDialog.init(orderBaseUuid, targetUserUuid, enterPriseName, 'DESIGN', orderStatus, totalPrice)
      },
      complain(orderBaseUuid, targetUserUuid, enterPriseName) {
          this.$refs.dialogRef.init(orderBaseUuid, targetUserUuid, enterPriseName);
      },
      // 申请开票
      openInvoice(item){
          let params = {
              uuid:item.issueInvoiceUuid,
              orderUuid:item.orderBaseUuid,
              orderNo:item.orderBase.orderNo,
              orderName:item.demandName,
              orderImg:"",
              orderType:'DESIGN',
              issueUser:item.orderBase.creatorUuid,
              invoiceMoney:item.offerPrice,
          };
          this.$refs.invoiceDialogRef.init(params);
      },
      // 下载文件
      downloadDesignFile(item){
          getDesignerDemandFile({isUpdate:0, demandUuid:item.demandUuid}).then((res)=>{
              if(res.success){
                  // 获取文件数组
                  let data = [];
                  if(res.data.modelList.length>0){
                      res.data.modelList.map((file) => {
                          let obj = {};
                          obj.name = file.name;
                          obj.url = file.url;
                          data.push(obj);
                      });
                      console.log(data);
                      downLoad(data, "设计师设计详情文件.zip");
                  }
              }
          });
      },
      // 聊天
      startChat(targetUuid) {
          let user = this.$store.state.userMessages;
          getRongCloudUser(targetUuid).then(res=> {
              console.log(res);
              this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
          });
      }
  },
};
</script>

<style scoped lang="less">
.printOrderListBox {
  padding: 94px 20px 20px;
  .orderListTabs {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    background: #fff;
    width: 100%;
    padding: 20px;
  }
  /deep/ .el-tabs__item {
    padding: 0 25px !important;
    text-align: center;

    &:hover {
      color: #3686d7;
    }

    &:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 12px;
      width: 1px;
      height: 15px;
      background-color: #e4e7ed;
      z-index: 1;
    }

    &:last-child:after {
      content: "";
      width: 0;
      height: 0;
    }
  }


// /deep/ .el-popover /deep/.el-popper{
//            width: 200px!important;
//          }

/deep/ .el-popover .el-popper{
  height: 300px;
}
  /deep/ .el-tabs__active-bar {
    height: 3px;
    background-color: #3686d7;
  }

  /deep/ .el-tabs__item.is-active {
    color: #3686d7;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
  }

  .orderSearchBox {
    display: flex;
    flex-wrap: wrap;
   .timeSearch{
                background-color:#f2f4f7;
                height: 35px;
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-right: 30px;
                border-radius: 8px;
                span{
                    font-size: 12px;
                    color: #c0c4cc!important;
                    font-weight: normal;
                    padding-left: 15px;
                    margin-right: 5px;
                }
                // /deep/ .el-range-input{
                //         background-color: #f2f4f7;
                //             &:hover, &:focus {
                //             background-color: #fff;
                //             // border: 1px solid #108EE9;
                //         }
                // }
                /deep/input::-webkit-input-placeholder {
                    color: #c0c4cc;
                    font-size: 12px;
                }
              /deep/.el-range-input:hover{
                  background-color: #fff!important;
              }
              /deep/ .el-date-editor .el-range-separator{
                  line-height: 25px;
                  color: #c0c4cc;
              }
             /deep/ .el-date-editor .el-range__close-icon{
                 line-height: 28px;
             }
              /deep/ .el-input__inner:hover  .el-range-input, /deep/ .el-input__inner:focus  .el-range-input{
                  background-color: white;
              }
                /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                .el-range-input{
                    background-color:#f2f4f7 ;
                }

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;

                }
            }
            /deep/ .el-icon-date:before {
                    content: "\E78E";
                    display: none;
                }
                /deep/.el-input__icon{
                    // display: none;
                }
            }
    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
        margin-bottom: 22px;
    }

    .resetBtn {
      color: #333333;
        margin-bottom: 22px;
    }
  }

  .orderListTable {
    .orderNomesaage {
        color: #888;
        text-align: center;
        padding: 15px 0;
    }
    .tableHeader {
      display: flex;
      width: 100%;
      height: 35px;
      line-height: 35px;
      background: #f3f7ff;
      border-radius: 5px;
      margin: 0 0 15px;
      li {
        text-align: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .tableBody {
      li {
        width: 100%;
        border: 1px solid #f2f2f2;
        border-radius: 10px;
        margin-bottom: 16px;

        .itemTop {
          width: 100%;
          height: 42px;
          background: #ebf3fb;
          line-height: 42px;
          font-size: 14px;
          color: #333;
          padding: 0 20px;
          display: flex;
          align-items: center;
          position: relative;

          div {
            margin-right: 30px;
          }

          .merchantInfo {
            display: flex;
            align-items: center;

            i {
              color: #3d7fff;
              font-size: 25px;
              cursor: pointer;
              padding-left: 5px;
              display: block;
            }

            img {
              display: block;
              padding-right: 5px;
            }
          }

          .complainBtn {
            color: #999;
            position: absolute;
            right: 20px;
          }
        }

        .itemBottom {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 13px;

          .orderInfo {
            padding: 20px;
            display: flex;

            img {
              display: block;
              width: 100px;
              height: 100px;
              border-radius: 10px;
              margin-right: 30px;
            }

            .infoContent {
              .infoName {
                font-size: 14px;
                color: #000000;
                padding-bottom: 10px;
              }

              .infoOther {
                font-size: 13px;
                color: #999999;
                padding-bottom: 2px;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }

          .designer {
            padding: 20px;
            i {
              color: #3d7fff;
              font-size: 25px;
              cursor: pointer;
              padding-left: 5px;
              display: block;
            }
          }

          .designerName {
            padding-bottom: 8px;
            img {
              width: 30px;
              height: 30px;
              border-radius: 50%;
            }
          }
          .status {
            font-size: 14px;
          }
          .operationBtn {
            display: block;
            color: #0c75d3;
            text-align: center;
            width: 100%;
            margin: 0;
          }
        }
      }
    }

    .name {
      flex: 1;
    }

    .price {
      width: 120px;
      text-align: center;
    }
    .time {
      width: 120px;
      text-align: center;
    }
    .num {
      width: 95px;
      text-align: center;
    }
    .designer {
      width: 95px;
      text-align: center;
    }
    .arguments {
      width: 294px;
    }

    .offer {
      width: 162px;
      text-align: center;
    }
    .expect {
      width: 162px;
      text-align: center;
    }
    .status {
      width: 124px;
      text-align: center;
    }
      .operation {
          width: 124px;
          text-align: center;
          .operationUploadBtn{
              width: 102px !important;
              height: 34px;
              padding: 0;
              line-height: 34px;
              text-align: center;
              font-weight: 700;
              color: rgba(0, 102, 204, 0.8);
              font-size: 14px;
              border-color: rgba(0, 102, 204, 0.8);
              display: block;
              margin: 0 auto 10px !important;
          }

      }
  }
  .pagination {
      margin-top: 20px;
      text-align: right;
  }
}
    .evaluateDialogBox {
        .evaluateItem {
            .name {
                font-size: 14px;
                color: #000;
                padding-bottom: 20px;
                font-weight: bold;
            }

            .content {
                padding-left: 20px;
                padding-bottom: 15px;
            }

            .rateItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;

                .name {
                    padding: 0 20px 0 0;
                    font-size: 13px;
                    color: #333;
                    min-width: 100px;
                    font-weight: normal;
                }
            }

            .evaluateTag {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-checkbox-button {
                    display: block;
                    margin-right: 20px;
                    margin-bottom: 15px;

                }

                /deep/ .el-checkbox-button__inner {
                    border: 1px solid #DCDFE6 !important;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    box-shadow: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/designOrderList.vue